import { shortenAdminSession } from '@cld/session-service';
import { isFlowInState } from '../../components/GuestBar/LoginAsFlow';
import { StatelessGuestBar } from '../../components/GuestBar/StatelessGuestBar';
import { RenewalModal } from '../../components/GuestBar/RenewalModal';
import { WelcomeModal } from '../../components/GuestBar/WelcomeModal';
import { useApplicationWrapperContext } from '../../context/applicationWrapper/ApplicationWrapper.context';
import { useUserData } from '../../context';
import { useLoginAs } from '../../features/loginAs/useLoginAs';

export const DefaultGuestBar = () => {
  const { isMobile } = useApplicationWrapperContext();
  const { userData } = useUserData();
  const userName = `${userData?.userInfo?.firstName ?? ''} ${userData?.userInfo?.lastName ?? ''}`;
  const flow = useLoginAs();
  const assetViewMode = flow.state.type === 'active.approved.viewingAssets' ? 'assets-on' : 'assets-off';

  return (
    <>
      {!isFlowInState(flow, 'inactive') && (
        <StatelessGuestBar
          data-test-specifier={`guest-bar-${assetViewMode}`}
          remainingSeconds={flow.remainingSeconds}
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          onTimerClick={shortenAdminSession}
          isMobile={isMobile}
          assetViewMode={'visible'}
          showEyeButton
        />
      )}
      {isFlowInState(flow, 'active.approved.welcome') && (
        <WelcomeModal
          data-test-specifier="welcome-modal"
          open
          onConfirm={flow.actions.confirm}
          onCancel={flow.actions.cancel}
          onClose={flow.actions.cancel}
          userName={userName}
        />
      )}
      {isFlowInState(flow, 'active.askingForRenewal') && (
        <RenewalModal
          data-test-specifier="renewal-modal"
          open
          onAccept={flow.actions.accept}
          onCancel={flow.actions.cancel}
          onClose={flow.actions.cancel}
          userName={userName}
        />
      )}
    </>
  );
};
